// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Fg-z","image":"Gg-z","imageNoBackground":"Hg-z"};